import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';

interface SectionHeaderProps {
    title: string;
    link?: { to: string; label: string };
    /** e.g. a filter button, shown on the right */
    children?: ReactNode;
}

const SectionHeader = ({title, link, children}: SectionHeaderProps) => (
    <div className="section-header">
        <h2>{title}</h2>
        {link && <Link to={link.to} className="section-link">{link.label} →</Link>}
        {children}
    </div>
);

export default SectionHeader;
